<script setup lang="ts">
import moment from "moment";
import BaseDatePicker from "vue-datepicker-next";

const model = defineModel<Date | undefined>();

const props = defineProps<{
  disabledDate?: (date: Date, currentValue?: Date[]) => boolean;
  parseTransform?: (date: Date) => Date;
  placeholder?: string;
}>();

const displayFormat = "MM/DD/YYYY";
const placeHolder = props.placeholder ?? `${displayFormat} or MMDDYYYY`;
const popupStyle = {
  zIndex: "20002",
};

function parseInput(value: string): Date | null {
  if (!value) return null;
  const m = moment(value, ["MM/DD/YYYY", "MMDDYYYY"], true);
  if (!m.isValid()) return null;
  const date = m.toDate();
  return props.parseTransform ? props.parseTransform(date) : date;
}

function stringifyDate(date: Date | null): string {
  if (!date) return "";
  return moment(date).format("MM/DD/YYYY");
}

const formatter = {
  stringify: stringifyDate,
  parse: parseInput,
};
</script>

<template>
  <BaseDatePicker
    v-model:value="model"
    type="date"
    :format="displayFormat"
    :formatter="formatter"
    :editable="true"
    class="po-date-picker"
    :style="{ width: '100%' }"
    :clearable="true"
    :placeholder="placeHolder"
    :disabled-date="props.disabledDate"
    :popup-style="popupStyle"
  />
</template>
